import { SetAbilities } from './ability';
import { createContext } from 'react';
import { createContextualCan } from '@casl/react';

export const AbilityContext = createContext<SetAbilities>(undefined!);

export default createContextualCan(AbilityContext.Consumer);